"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M8.02 1a7.01 7.01 0 106.55 9.53.5.5 0 11.94.36A8.02 8.02 0 010 8a8.03 8.03 0 0115.4-3.13.5.5 0 11-.92.4A7.03 7.03 0 008.02 1zm1.3 3.4c.2.19.2.5 0 .7l-2.3 2.4h8.48a.5.5 0 010 1H7.09l2.24 2.4a.5.5 0 11-.73.68L5.52 8.3a.5.5 0 010-.68l3.09-3.2c.19-.2.5-.2.7-.02z"
}));

exports.default = _default;